<template>
  <router-link
    v-tippy="{
      placement: 'right',
      content: !hasNetworkAccess && $t('modules.application.offline'),
      interactive: true,
      allowHTML: true,
      appendTo,
    }"
    class="relative flex justify-center py-4"
    :class="!hasNetworkAccess && 'grayscale'"
    :aria-label="$t('modules.application.navbar.homepage')"
    to="/"
  >
    <component :is="theme.logos.standard" />
  </router-link>
</template>

<script lang="ts" setup>
import { useOnline } from '@vueuse/core'
import { theme } from '@klausapp/ui-kit'

const hasNetworkAccess = useOnline()
const appendTo = document.body
</script>
